import React, { useState } from "react";
import "./UserModal.css";

interface UserModalProps {
  type?: "message" | "feedback";
  name: string;
  studyId: string;
  loading?: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
}

const UserModal: React.FC<UserModalProps> = ({
  type,
  name,
  studyId,
  loading = false,
  onClose,
  onSend,
}) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
      setMessage("");
    }
  };

  return (
    <div className="user-modal-overlay">
      <div className="user-modal-content">
        <h2 className="user-modal-title">
          {type === "message" ? "Send Message" : "Add Feedback"}
        </h2>

        <div className="user-modal-middle">
          <div className="user-modal-info">
            <div>
              <strong>Name:</strong> {name}
            </div>
            <div>
              <strong>Study ID:</strong> {studyId}
            </div>
          </div>

          <label className="user-modal-label">
            {type === "message" ? "Message" : "Feedback"}{" "}
            <span className="required">*</span>
          </label>

          <textarea
            className="user-modal-textarea"
            placeholder={
              type === "message" ? "Enter message here" : "Enter feedback here"
            }
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-send" onClick={handleSend} disabled={loading}>
            {loading ? "Submitting..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
